// extracted by mini-css-extract-plugin
export default {"flex-column":"postForm_flex-column__ZKcYL","post-form":"postForm_post-form__pBtqK","flex-row":"postForm_flex-row__PF1Br","page-size":"postForm_page-size__90M1a"};